import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import Separator from '../../../components/helpers/Separator'
import TagsLoader from './_load/TagsLoader'
import TagsTable from './table/TagsTable'

/**
 * Cadastro de tags de atividade, aberto como modal a partir de "Mais opções" na listagem de
 * Atividades (mesmo local/padrão de outras configurações do módulo, como Campos Adicionais e
 * Semáforo) — não é mais uma página própria em `/tags`.
 */
const TagsModal = props => {
  return (
    <ControlledModal width="46rem" {...props}>
      <PermissionChecker permission="setupServiceOrderTag">
        <FilterHandler tempStorageNamespace="tags" initialState={{}}>
          <TagsLoader>
            <ModalHeader />

            <HorizontalLine thin lineColor={COLORS.light2} />
            <Separator weight={2} />

            <TagsTable />

            <Separator weight={5} />
          </TagsLoader>
        </FilterHandler>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default TagsModal
